import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/statuses';

export async function query(): Promise<any> {
	const response: Response = await BBApi.get(rootUrl);
	const json: any = await response.json();
	return json;
}

export async function get(id: number): Promise<any> {
	throw new Error('Not implemented');
}

export async function create(status: any): Promise<any> {
	throw new Error('Not implemented');
}

export async function update(id: number, status: any): Promise<void> {
	throw new Error('Not implemented');
}

export async function remove(id: number): Promise<void> {
	throw new Error('Not implemented');
}
